import { gql } from "@apollo/client";

export const SPLIT_JOB_DAY = gql`
    mutation splitJobDay($days: [SplitJobDayInputType]!, $foremanAssignmentId: Int!, $originalJobDayId: Int!) {
        splitJobDay(days: $days, foremanAssignmentId: $foremanAssignmentId, originalJobDayId: $originalJobDayId) {
            newJobDays {
                id
            }
        }
    }
`

export const PROCESS_JOB_DAY_TIME_TICKETS = gql`
    mutation processJobDayTimeTickets($id: Int!, $scopeOfWork: String!, $workType: String!, $numFrames: Int!, $workType1: String!, $workType2: String!  $safetyNotes: String!, $customerSignature: Upload!, $customerComments: String, $assignments: [ProcessTimeTicketInputType]!) {
        processJobDayTimeTickets(id: $id, scopeOfWork: $scopeOfWork, safetyNotes: $safetyNotes, customerSignature: $customerSignature, customerComments: $customerComments, assignments: $assignments, workType: $workType, numFrames: $numFrames, workType1: $workType1, workType2: $workType2) {
            jobDay {
                id
                customerSignature
            }
        }
    }
`